import styled from 'styled-components';
import {Link} from 'gatsby';

const FlatButton = styled(Link)`
  color: #000;
  opacity: 0.6;
  transition: 0.3s ease-in-out;
  font-family: Rockwell, serif;
  cursor: pointer;
  :hover {
    opacity: 1;
  }
 
`;

const Button = styled.button`
  width: 250px;
  height: 50px;
  background: #BCAAAA;
  color: #000;
  font-family: Rockwell, serif;
  margin-top: 24px;
  margin-bottom: 24px;
  transition: 0.3s ease-in-out;
  border: 0;
  cursor: pointer;
  :hover {
    color: #fff;
    box-shadow: 6px 6px #e4cece;
  }
`;

export {FlatButton , Button};

